<template>
  <form @submit.prevent="" @keydown.enter.prevent="">
    <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 80vh; height: fit-content;">
      <header class="modal-card-head">
        <p class="modal-card-title">
          New Movement
          <span style="font-size:1rem; text-overflow: elipsis">{{ plant.name }}</span>
        </p>
      </header>
      <section class="modal-card-body">
        <b-field grouped>
          <b-field label="Shift">
            <b-select v-model="shift" placeholder="Shift">
              <option value="AM">
                AM
              </option>
              <option value="PM">
                PM
              </option>
              <option value="Night">
                Night
              </option>
            </b-select>
          </b-field>
          <b-field label="Activity">
            <b-button :type="operation == 'washing' ? 'is-success' : 'is-light'" @click="changeActivity('washing')">
              Manual Washing
            </b-button>
            <b-button :type="operation == 'machineWash' ? 'is-success' : 'is-light'" @click="changeActivity('machineWash')">
              Machine Washing
            </b-button>
            <b-button :type="operation == 'repair' ? 'is-success' : 'is-light'" @click="changeActivity('repair')">
              Repair
            </b-button>
            <b-button :type="operation == 'quality' ? 'is-success' : 'is-light'" @click="changeActivity('quality')">
              Random Control
            </b-button>
            <b-button :type="operation == 'forklift' ? 'is-success' : 'is-light'" @click="changeActivity('forklift')">
              Forklift
            </b-button>
            <b-button :type="operation == 'special' ? 'is-success' : 'is-light'" @click="changeActivity('special')">
              Special
            </b-button>
          </b-field>
          <b-field label="Crate Type">
            <b-select v-model="crateType" placeholder="Crate Type">
              <option value="1">
                1
              </option>
              <option value="5.1">
                5.1
              </option>
              <option value="5.2" selected>
                5.2
              </option>
              <option value="5.5">
                5.5
              </option>
              <option value="7.1">
                7.1
              </option>
              <option value="7.2">
                7.2
              </option>
              <option value="LIDS">
                LIDS
              </option>
              <option value="GPSFood">
                GPS Food
              </option>
              <option value="ZEON">
                ZEON
              </option>
              <option value="RHODIA">
                RHODIA
              </option>
            </b-select>
          </b-field>
        </b-field>
        <div v-if="operation != null">
          <b-field class="mb-1" grouped>
            <b-field label="Date">
              <b-datepicker
                v-model="date"
                name="date"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="Date"
              />
            </b-field>
            <div v-if="operation === 'washing' && shift === 'AM'">
              <b-field label="Hours">
                <b-input v-model="amWashingHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'washing' && shift === 'PM'">
              <b-field label="Hours">
                <b-input v-model="pmWashingHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'washing' && shift === 'Night'">
              <b-field label="Hours">
                <b-input v-model="nightWashingHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'machineWash' && shift === 'AM'">
              <b-field label="Hours">
                <b-input v-model="amMachineHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'machineWash' && shift === 'PM'">
              <b-field label="Hours">
                <b-input v-model="pmMachineHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'machineWash' && shift === 'Night'">
              <b-field label="Hours">
                <b-input v-model="nightMachineHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'forklift' && shift === 'AM'">
              <b-field label="Hours">
                <b-input v-model="amForkliftHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'forklift' && shift === 'PM'">
              <b-field label="Hours">
                <b-input v-model="pmForkliftHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
            <div v-if="operation === 'forklift' && shift === 'Night'">
              <b-field label="Hours">
                <b-input v-model="nightForkliftHours" type="number" step="0.25" min="0" />
              </b-field>
            </div>
          </b-field>
        </div>
        <div v-if="operation === 'washing' && shift === 'AM'">
          <b-field label="Quantity washed successfully">
            <b-input v-model="amWashedClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty">
            <b-input v-model="amWashedDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair">
            <b-input v-model="amWashedRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="amWashingComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'washing' && shift === 'PM'">
          <b-field label="Quantity washed successfully">
            <b-input v-model="pmWashedClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty">
            <b-input v-model="pmWashedDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair">
            <b-input v-model="pmWashedRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="pmWashingComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'washing' && shift === 'Night'">
          <b-field label="Quantity washed successfully">
            <b-input v-model="nightWashedClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty">
            <b-input v-model="nightWashedDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair">
            <b-input v-model="nightWashedRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="nightWashingComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'machineWash' && shift === 'AM'">
          <b-field label="Quantity washed successfully">
            <b-input v-model="amMachineClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty">
            <b-input v-model="amMachineDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair">
            <b-input v-model="amMachineRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="amMachineComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'machineWash' && shift === 'PM'">
          <b-field label="Quantity washed successfully">
            <b-input v-model="pmMachineClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty">
            <b-input v-model="pmMachineDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair">
            <b-input v-model="pmMachineRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="pmMachineComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'machineWash' && shift === 'Night'">
          <b-field label="Quantity washed successfully">
            <b-input v-model="nightMachineClean" type="number" />
          </b-field>
          <b-field label="Quantity rejected dirty">
            <b-input v-model="nightMachineDirty" type="number" />
          </b-field>
          <b-field label="Quantity rejected to repair">
            <b-input v-model="nightMachineRepair" type="number" />
          </b-field>
          <b-field label="Comment">
            <b-input v-model="nightMachineComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'repair' && shift === 'AM'">
          <b-field label="Crates Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="amRepairHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="amRepairedCrates" type="number" />
            </b-field>
          </b-field>
          <b-field label="Doors Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="amDoorHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="amRepairedDoors" type="number" />
            </b-field>
          </b-field>
          <b-field label="Comment">
            <b-input v-model="amRepairComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'repair' && shift === 'PM'">
          <b-field label="Crates Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="pmRepairHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="pmRepairedCrates" type="number" />
            </b-field>
          </b-field>
          <b-field label="Doors Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="pmDoorHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="pmRepairedDoors" type="number" />
            </b-field>
          </b-field>
          <b-field label="Comment">
            <b-input v-model="pmRepairComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'repair' && shift === 'Night'">
          <b-field label="Crates Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="nightRepairHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="nightRepairedCrates" type="number" />
            </b-field>
          </b-field>
          <b-field label="Doors Repaired" grouped>
            <b-field label="Hours">
              <b-input v-model="nightDoorHours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="nightRepairedDoors" type="number" />
            </b-field>
          </b-field>
          <b-field label="Comment">
            <b-input v-model="nightRepairComment" type="text" />
          </b-field>
        </div>
        <div v-if="operation === 'quality' && shift === 'AM'">
          <b-field label="Good Crates">
            <b-input v-model="amGoodCrates" type="number" />
          </b-field>
          <b-field label="Bad Crates">
            <b-input v-model="amBadCrates" type="number" />
          </b-field>
          <b-field grouped>
            <b-field label="Comment">
              <b-input v-model="amQualityComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'quality' && shift === 'PM'">
          <b-field label="Good Crates">
            <b-input v-model="pmGoodCrates" type="number" />
          </b-field>
          <b-field label="Bad Crates">
            <b-input v-model="pmBadCrates" type="number" />
          </b-field>
          <b-field grouped>
            <b-field label="Comment">
              <b-input v-model="pmQualityComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'quality' && shift === 'Night'">
          <b-field label="Good Crates">
            <b-input v-model="nightGoodCrates" type="number" />
          </b-field>
          <b-field label="Bad Crates">
            <b-input v-model="nightBadCrates" type="number" />
          </b-field>
          <b-field grouped>
            <b-field label="Comment">
              <b-input v-model="nightQualityComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'forklift' && shift === 'AM'">
          <b-field label="Dirty" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="amForklift.dirty.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="amForklift.dirty.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Clean" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="amForklift.clean.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="amForklift.clean.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Repair" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="amForklift.repair.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="amForklift.repair.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field label="Forklift comment">
              <b-input v-model="amForkliftComment" type="text" />
            </b-field>
          </b-field>
          <b-field label="Yard" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Clean rejected to dirty">
              <b-input v-model="amForklift.park.cleanRejectedDirty" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="amForklift.park.cleanRejectedDirtyComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Clean rejected to repair">
              <b-input v-model="amForklift.park.cleanRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="amForklift.park.cleanRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Dirty rejected to repair">
              <b-input v-model="amForklift.park.dirtyRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="amForklift.park.dirtyRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'forklift' && shift === 'PM'">
          <b-field label="Dirty" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="pmForklift.dirty.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="pmForklift.dirty.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Clean" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="pmForklift.clean.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="pmForklift.clean.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Repair" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="pmForklift.repair.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="pmForklift.repair.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field label="Forklift comment">
              <b-input v-model="pmForkliftComment" type="text" />
            </b-field>
          </b-field>
          <b-field label="Yard" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Clean rejected to dirty">
              <b-input v-model="pmForklift.park.cleanRejectedDirty" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="pmForklift.park.cleanRejectedDirtyComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Clean rejected to repair">
              <b-input v-model="pmForklift.park.cleanRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="pmForklift.park.cleanRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Dirty rejected to repair">
              <b-input v-model="pmForklift.park.dirtyRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="pmForklift.park.dirtyRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'forklift' && shift === 'Night'">
          <b-field label="Dirty" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="nightForklift.dirty.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="nightForklift.dirty.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Clean" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="nightForklift.clean.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="nightForklift.clean.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field label="Repair" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Received">
              <b-input v-model="nightForklift.repair.received" type="number" />
            </b-field>
            <b-field label="Delivered">
              <b-input v-model="nightForklift.repair.delivered" type="number" />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field label="Forklift comment">
              <b-input v-model="nightForkliftComment" type="text" />
            </b-field>
          </b-field>
          <b-field label="Yard" custom-class="is-large mb-1" class="mb-1" grouped>
            <b-field label="Clean rejected to dirty">
              <b-input v-model="nightForklift.park.cleanRejectedDirty" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="nightForklift.park.cleanRejectedDirtyComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Clean rejected to repair">
              <b-input v-model="nightForklift.park.cleanRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="nightForklift.park.cleanRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
          <b-field class="mb-1" grouped>
            <b-field label="Dirty rejected to repair">
              <b-input v-model="nightForklift.park.dirtyRejectedRepair" type="number" />
            </b-field>
            <b-field label="Rejected Comment">
              <b-input v-model="nightForklift.park.dirtyRejectedRepairComment" type="text" />
            </b-field>
          </b-field>
        </div>
        <div v-if="operation === 'special'">
          <b-field v-for="(line, index) in specialLines" :key="`${shift}Special${index}`" class="mb-1" grouped>
            <b-field label="Hours">
              <b-input v-model="line.hours" type="number" step="0.25" min="0" />
            </b-field>
            <b-field label="Crates">
              <b-input v-model="line.crates" type="number" />
            </b-field>
            <b-field label="Comment" expanded>
              <b-input v-model="line.comment" type="text" />
            </b-field>
            <b-field label=" ">
              <b-button
                type="is-danger"
                icon-left="minus"
                style="margin-top: 50%;"
                :disabled="specialLines.length === 1"
                @click="removeSpecialLine(index)"
              />
            </b-field>
          </b-field>
          <b-button type="is-info" icon-left="plus" @click="addSpecialLine">
            Add special activity
          </b-button>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-info is-fullwidth" @click="submit">
          {{ $t('global.submit') }}
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
// import enduserClosureMail from '@/services/v3/enduserClosureMail'

export default {
  props: {
    plant: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      output: [],
      date: new Date(),
      crateType: '5.2',
      amWashedClean: 0,
      amWashedDirty: 0,
      amWashedRepair: 0,
      amMachineClean: 0,
      amMachineDirty: 0,
      amMachineRepair: 0,
      amRepairedCrates: 0,
      amRepairedDoors: 0,
      amGoodCrates: 0,
      amBadCrates: 0,
      amSpecial: [{ hours: 0, crates: 0, comment: '' }],
      amForklift: {
        dirty: {
          received: 0,
          delivered: 0
        },
        clean: {
          received: 0,
          delivered: 0
        },
        repair: {
          received: 0,
          delivered: 0
        },
        park: {
          cleanRejectedDirty: 0,
          cleanRejectedDirtyComment: '',
          cleanRejectedRepair: 0,
          cleanRejectedRepairComment: '',
          dirtyRejectedRepair: 0,
          dirtyRejectedRepairComment: ''
        },
        destroyed: {
          cleanDestroyed: 0,
          dirtyDestroyed: 0,
          repairDestroyed: 0
        }
      },
      amWashingComment: '',
      amMachineComment: '',
      amRepairComment: '',
      amForkliftComment: '',
      amQualityComment: '',
      amWashingHours: 0,
      amMachineHours: 0,
      amRepairHours: 0,
      amDoorHours: 0,
      amForkliftHours: 0,
      pmWashedClean: 0,
      pmWashedDirty: 0,
      pmWashedRepair: 0,
      pmMachineClean: 0,
      pmMachineDirty: 0,
      pmMachineRepair: 0,
      pmRepairedCrates: 0,
      pmRepairedDoors: 0,
      pmGoodCrates: 0,
      pmBadCrates: 0,
      pmSpecial: [{ hours: 0, crates: 0, comment: '' }],
      pmForklift: {
        dirty: {
          received: 0,
          delivered: 0
        },
        clean: {
          received: 0,
          delivered: 0
        },
        repair: {
          received: 0,
          delivered: 0
        },
        park: {
          cleanRejectedDirty: 0,
          cleanRejectedDirtyComment: '',
          cleanRejectedRepair: 0,
          cleanRejectedRepairComment: '',
          dirtyRejectedRepair: 0,
          dirtyRejectedRepairComment: ''
        },
        destroyed: {
          cleanDestroyed: 0,
          dirtyDestroyed: 0,
          repairDestroyed: 0
        }
      },
      pmWashingComment: '',
      pmMachineComment: '',
      pmRepairComment: '',
      pmForkliftComment: '',
      pmQualityComment: '',
      pmWashingHours: 0,
      pmMachineHours: 0,
      pmRepairHours: 0,
      pmDoorHours: 0,
      pmForkliftHours: 0,
      nightWashedClean: 0,
      nightWashedDirty: 0,
      nightWashedRepair: 0,
      nightMachineClean: 0,
      nightMachineDirty: 0,
      nightMachineRepair: 0,
      nightRepairedCrates: 0,
      nightRepairedDoors: 0,
      nightGoodCrates: 0,
      nightBadCrates: 0,
      nightSpecial: [{ hours: 0, crates: 0, comment: '' }],
      nightForklift: {
        dirty: {
          received: 0,
          delivered: 0
        },
        clean: {
          received: 0,
          delivered: 0
        },
        repair: {
          received: 0,
          delivered: 0
        },
        park: {
          cleanRejectedDirty: 0,
          cleanRejectedDirtyComment: '',
          cleanRejectedRepair: 0,
          cleanRejectedRepairComment: '',
          dirtyRejectedRepair: 0,
          dirtyRejectedRepairComment: ''
        },
        destroyed: {
          cleanDestroyed: 0,
          dirtyDestroyed: 0,
          repairDestroyed: 0
        }
      },
      nightWashingComment: '',
      nightMachineComment: '',
      nightRepairComment: '',
      nightForkliftComment: '',
      nightQualityComment: '',
      nightWashingHours: 0,
      nightMachineHours: 0,
      nightRepairHours: 0,
      nightDoorHours: 0,
      nightForkliftHours: 0,
      operation: null,
      shift: 'AM'
    }
  },
  computed: {
    specialLines () {
      return this.specialLinesFor(this.shift)
    }
  },
  mounted: async function () {
    this.date.setDate(this.date.getDate() - 1)
  },
  methods: {
    changeActivity (newActivity) {
      this.operation = newActivity
    },
    specialLinesFor (shift) {
      if (shift === 'PM') return this.pmSpecial
      if (shift === 'Night') return this.nightSpecial
      return this.amSpecial
    },
    addSpecialLine () {
      this.specialLines.push({ hours: 0, crates: 0, comment: '' })
    },
    removeSpecialLine (index) {
      this.specialLines.splice(index, 1)
    },
    // A special activity is only identifiable by its comment, so hours without one are rejected
    missingSpecialComments () {
      const missing = []
      const shifts = ['AM', 'PM', 'Night']
      shifts.forEach((shift) => {
        this.specialLinesFor(shift).forEach((line, index) => {
          if (line.hours > 0 && String(line.comment).trim() === '') {
            missing.push(`${shift} line ${index + 1}`)
          }
        })
      })
      return missing
    },
    async submit () {
      const missingComments = this.missingSpecialComments()
      if (missingComments.length > 0) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: `A comment is required for every special activity with hours. Please fill out: ${missingComments.join(', ')}`,
          duration: 5000
        })
        return
      }
      if (this.amWashedClean > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.amWashedClean,
            operation: 'washing',
            comment: this.amWashingComment,
            shift: 'AM',
            hours: this.amWashingHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amWashedDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.amWashedDirty,
            operation: 'washing__rejectedDirty',
            comment: this.amWashingComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amWashedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.amWashedRepair,
            operation: 'washing__rejectedRepair',
            comment: this.amWashingComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amMachineClean > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.amMachineClean,
            operation: 'machineWash',
            comment: this.amMachineComment,
            shift: 'AM',
            hours: this.amMachineHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amMachineDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.amMachineDirty,
            operation: 'machineWash__rejectedDirty',
            comment: this.amMachineComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amMachineRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.amMachineRepair,
            operation: 'machineWash__rejectedRepair',
            comment: this.amMachineComment,
            shift: 'AM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amRepairedCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.amRepairedCrates,
            operation: 'repair',
            comment: this.amRepairComment,
            shift: 'AM',
            hours: this.amRepairHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amRepairedDoors > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DOOR`,
            status_crate_end: `${this.crateType}__DOOR`,
            num_crates: this.amRepairedDoors,
            operation: 'repair__door',
            comment: this.amRepairComment,
            shift: 'AM',
            hours: this.amDoorHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amGoodCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__GOOD`,
            status_crate_end: `${this.crateType}__GOOD`,
            num_crates: this.amGoodCrates,
            operation: 'quality__good',
            comment: this.amQualityComment,
            shift: 'AM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amBadCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__BAD`,
            status_crate_end: `${this.crateType}__BAD`,
            num_crates: this.amBadCrates,
            operation: 'quality__bad',
            comment: this.amQualityComment,
            shift: 'AM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.dirty.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.amForklift.dirty.received,
            operation: 'forklift__receivedDirty',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.dirty.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.amForklift.dirty.delivered,
            operation: 'forklift__deliveredDirty',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.clean.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.amForklift.clean.received,
            operation: 'forklift__receivedClean',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.clean.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.amForklift.clean.delivered,
            operation: 'forklift__deliveredClean',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.repair.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.amForklift.repair.received,
            operation: 'forklift__receivedRepair',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.repair.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.amForklift.repair.delivered,
            operation: 'forklift__deliveredRepair',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.park.cleanRejectedDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.amForklift.park.cleanRejectedDirty,
            operation: 'forklift__cleanRejectedDirty',
            comment: this.amForklift.park.cleanRejectedDirtyComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.park.cleanRejectedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.amForklift.park.cleanRejectedRepair,
            operation: 'forklift__cleanRejectedRepair',
            comment: this.amForklift.park.cleanRejectedRepairComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.park.dirtyRejectedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.amForklift.park.dirtyRejectedRepair,
            operation: 'forklift__dirtyRejectedRepair',
            comment: this.amForklift.park.dirtyRejectedRepairComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.destroyed.dirtyDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.amForklift.destroyed.dirtyDestroyed,
            operation: 'forklift__dirtyDestroyed',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.destroyed.cleanDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.amForklift.destroyed.cleanDestroyed,
            operation: 'forklift__cleanDestroyed',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.amForklift.destroyed.repairDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.amForklift.destroyed.repairDestroyed,
            operation: 'forklift__repairDestroyed',
            comment: this.amForkliftComment,
            shift: 'AM',
            hours: this.amForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      this.amSpecial.forEach((line) => {
        if (line.hours > 0) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crate_start: `${this.crateType}__SPECIAL`,
              status_crate_end: `${this.crateType}__SPECIAL`,
              num_crates: line.crates,
              operation: 'special',
              comment: line.comment,
              shift: 'AM',
              hours: line.hours,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
      })
      if (this.pmWashedClean > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.pmWashedClean,
            operation: 'washing',
            comment: this.pmWashingComment,
            shift: 'PM',
            hours: this.pmWashingHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmWashedDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.pmWashedDirty,
            operation: 'washing__rejectedDirty',
            comment: this.pmWashingComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmWashedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.pmWashedRepair,
            operation: 'washing__rejectedRepair',
            comment: this.pmWashingComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmMachineClean > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.pmMachineClean,
            operation: 'machineWash',
            comment: this.pmMachineComment,
            shift: 'PM',
            hours: this.pmMachineHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmMachineDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.pmMachineDirty,
            operation: 'machineWash__rejectedDirty',
            comment: this.pmMachineComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmMachineRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.pmMachineRepair,
            operation: 'machineWash__rejectedRepair',
            comment: this.pmMachineComment,
            shift: 'PM',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmRepairedCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.pmRepairedCrates,
            operation: 'repair',
            comment: this.pmRepairComment,
            shift: 'PM',
            hours: this.pmRepairHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmRepairedDoors > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DOOR`,
            status_crate_end: `${this.crateType}__DOOR`,
            num_crates: this.pmRepairedDoors,
            operation: 'repair__door',
            comment: this.pmRepairComment,
            shift: 'PM',
            hours: this.pmDoorHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmGoodCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__GOOD`,
            status_crate_end: `${this.crateType}__GOOD`,
            num_crates: this.pmGoodCrates,
            operation: 'quality__good',
            comment: this.pmQualityComment,
            shift: 'PM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmBadCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__BAD`,
            status_crate_end: `${this.crateType}__BAD`,
            num_crates: this.pmBadCrates,
            operation: 'quality__bad',
            comment: this.pmQualityComment,
            shift: 'PM',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.dirty.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.pmForklift.dirty.received,
            operation: 'forklift__receivedDirty',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.dirty.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.pmForklift.dirty.delivered,
            operation: 'forklift__deliveredDirty',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.clean.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.pmForklift.clean.received,
            operation: 'forklift__receivedClean',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.clean.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.pmForklift.clean.delivered,
            operation: 'forklift__deliveredClean',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.repair.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.pmForklift.repair.received,
            operation: 'forklift__receivedRepair',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.repair.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.pmForklift.repair.delivered,
            operation: 'forklift__deliveredRepair',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.park.cleanRejectedDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.pmForklift.park.cleanRejectedDirty,
            operation: 'forklift__cleanRejectedDirty',
            comment: this.pmForklift.park.cleanRejectedDirtyComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.park.cleanRejectedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.pmForklift.park.cleanRejectedRepair,
            operation: 'forklift__cleanRejectedRepair',
            comment: this.pmForklift.park.cleanRejectedRepairComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.park.dirtyRejectedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.pmForklift.park.dirtyRejectedRepair,
            operation: 'forklift__dirtyRejectedRepair',
            comment: this.pmForklift.park.dirtyRejectedRepairComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.destroyed.dirtyDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.pmForklift.destroyed.dirtyDestroyed,
            operation: 'forklift__dirtyDestroyed',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.destroyed.cleanDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.pmForklift.destroyed.cleanDestroyed,
            operation: 'forklift__cleanDestroyed',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.pmForklift.destroyed.repairDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.pmForklift.destroyed.repairDestroyed,
            operation: 'forklift__repairDestroyed',
            comment: this.pmForkliftComment,
            shift: 'PM',
            hours: this.pmForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      this.pmSpecial.forEach((line) => {
        if (line.hours > 0) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crate_start: `${this.crateType}__SPECIAL`,
              status_crate_end: `${this.crateType}__SPECIAL`,
              num_crates: line.crates,
              operation: 'special',
              comment: line.comment,
              shift: 'PM',
              hours: line.hours,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
      })
      if (this.nightWashedClean > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.nightWashedClean,
            operation: 'washing',
            comment: this.nightWashingComment,
            shift: 'Night',
            hours: this.nightWashingHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightWashedDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.nightWashedDirty,
            operation: 'washing__rejectedDirty',
            comment: this.nightWashingComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightWashedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.nightWashedRepair,
            operation: 'washing__rejectedRepair',
            comment: this.nightWashingComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightMachineClean > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.nightMachineClean,
            operation: 'machineWash',
            comment: this.nightMachineComment,
            shift: 'Night',
            hours: this.nightMachineHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightMachineDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.nightMachineDirty,
            operation: 'machineWash__rejectedDirty',
            comment: this.nightMachineComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightMachineRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.nightMachineRepair,
            operation: 'machineWash__rejectedRepair',
            comment: this.nightMachineComment,
            shift: 'Night',
            hours: null,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightRepairedCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.nightRepairedCrates,
            operation: 'repair',
            comment: this.nightRepairComment,
            shift: 'Night',
            hours: this.nightRepairHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightRepairedDoors > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DOOR`,
            status_crate_end: `${this.crateType}__DOOR`,
            num_crates: this.nightRepairedDoors,
            operation: 'repair__door',
            comment: this.nightRepairComment,
            shift: 'Night',
            hours: this.nightDoorHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightGoodCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__GOOD`,
            status_crate_end: `${this.crateType}__GOOD`,
            num_crates: this.nightGoodCrates,
            operation: 'quality__good',
            comment: this.nightQualityComment,
            shift: 'Night',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightBadCrates > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__BAD`,
            status_crate_end: `${this.crateType}__BAD`,
            num_crates: this.nightBadCrates,
            operation: 'quality__bad',
            comment: this.nightQualityComment,
            shift: 'Night',
            hours: 0,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.dirty.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.nightForklift.dirty.received,
            operation: 'forklift__receivedDirty',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.dirty.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.nightForklift.dirty.delivered,
            operation: 'forklift__deliveredDirty',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.clean.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__CLEAN`,
            num_crates: this.nightForklift.clean.received,
            operation: 'forklift__receivedClean',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.clean.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.nightForklift.clean.delivered,
            operation: 'forklift__deliveredClean',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.repair.received > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__RECEIVED`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.nightForklift.repair.received,
            operation: 'forklift__receivedRepair',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.repair.delivered > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DELIVERED`,
            num_crates: this.nightForklift.repair.delivered,
            operation: 'forklift__deliveredRepair',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.park.cleanRejectedDirty > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DIRTY`,
            num_crates: this.nightForklift.park.cleanRejectedDirty,
            operation: 'forklift__cleanRejectedDirty',
            comment: this.nightForklift.park.cleanRejectedDirtyComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.park.cleanRejectedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.nightForklift.park.cleanRejectedRepair,
            operation: 'forklift__cleanRejectedRepair',
            comment: this.nightForklift.park.cleanRejectedRepairComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.park.dirtyRejectedRepair > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__REPAIR`,
            num_crates: this.nightForklift.park.dirtyRejectedRepair,
            operation: 'forklift__dirtyRejectedRepair',
            comment: this.nightForklift.park.dirtyRejectedRepairComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.destroyed.dirtyDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__DIRTY`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.nightForklift.destroyed.dirtyDestroyed,
            operation: 'forklift__dirtyDestroyed',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.destroyed.cleanDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__CLEAN`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.nightForklift.destroyed.cleanDestroyed,
            operation: 'forklift__cleanDestroyed',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      if (this.nightForklift.destroyed.repairDestroyed > 0) {
        this.output.push(
          {
            id_site: this.plant.id,
            status_crate_start: `${this.crateType}__REPAIR`,
            status_crate_end: `${this.crateType}__DESTROYED`,
            num_crates: this.nightForklift.destroyed.repairDestroyed,
            operation: 'forklift__repairDestroyed',
            comment: this.nightForkliftComment,
            shift: 'Night',
            hours: this.nightForkliftHours,
            date: this.date.toLocaleDateString('en-CA')
          }
        )
      }
      this.nightSpecial.forEach((line) => {
        if (line.hours > 0) {
          this.output.push(
            {
              id_site: this.plant.id,
              status_crate_start: `${this.crateType}__SPECIAL`,
              status_crate_end: `${this.crateType}__SPECIAL`,
              num_crates: line.crates,
              operation: 'special',
              comment: line.comment,
              shift: 'Night',
              hours: line.hours,
              date: this.date.toLocaleDateString('en-CA')
            }
          )
        }
      })
      try {
        this.$emit('submit', this.output)
        return
      } catch (error) {
        this.$buefy.toast.open({ type: 'is-danger', message: error.message, duration: 3000 })
      }
    }
  }
}
</script>

<style>
</style>
